import { render, staticRenderFns } from "./ChatInfoThumb.vue?vue&type=template&id=071b40da&scoped=true&"
import script from "./ChatInfoThumb.vue?vue&type=script&lang=js&"
export * from "./ChatInfoThumb.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoThumb.vue?vue&type=style&index=0&id=071b40da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b40da",
  null
  
)

export default component.exports